import Colors from "@src/constants/Colors";
import styled from "styled-components";

export const CheckWrapper = styled.div<{
  isNotEmpty: boolean;
  isDesktop: boolean;
}>`
  min-height: ${(props) => (props.isDesktop ? "391px" : "")};
  .note {
    font-family: Ringside Regular-Book;
    color: ${Colors.black};
    margin-bottom: 8px;
  }
`;

export const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2vw;
`;
